var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { IdStyles } from "../../../../../../less/IdStyles";
import { actionBeginBuyWithGoldProcess } from "../../../../../buy-with-gold/actionBuyWithGold";
import { Icon } from "../../../../../generic/icon/Icon";
import { actionShowMeQuestTaskUseOutskirt } from "../../../../../show-me/actionShowMe";
import { ButtonQuestShowMe } from "../ButtonQuestShowMe";
import { QuestSkipButton } from "../QuestSkipButton";
import { QuestTask } from "../QuestTask";
var _QuestTaskUseOutskirt = function (props) {
    var tasks = props.tasks, questInfoTasks = props.questInfoTasks, quest = props.quest, onTrySkip = props.onTrySkip, onClickShowMe = props.onClickShowMe;
    var task = tasks;
    var list = task.map(function (value) {
        var requiredTaskInfo = questInfoTasks.find(function (val) { return val.index === value.index; });
        var currentdAmount = requiredTaskInfo.amount || 0;
        var taskCompleted = currentdAmount >= value.amount;
        var icon = React.createElement(Icon, { icon: quest.buttonIconRight, styleId: IdStyles.IconExtraLarge });
        var taskProps = {
            currentAmount: currentdAmount,
            icon: icon,
            locaKey: value.locaKey,
            requiredAmount: value.amount,
            taskCompleted: taskCompleted,
        };
        var skipButtonProps = {
            currentAmount: currentdAmount,
            onTrySkip: onTrySkip,
            questId: quest.id,
            requiredAmount: value.amount,
            skipCost: value.skipCost,
            taskCompleted: taskCompleted,
            taskIndex: value.index,
        };
        return (React.createElement(QuestTask, __assign({ key: value.locaKey + "_" + icon }, taskProps),
            React.createElement(QuestSkipButton, __assign({}, skipButtonProps)),
            React.createElement(ButtonQuestShowMe, { taskCompleted: taskCompleted, onClick: function () { return onClickShowMe(value); }, questTask: value })));
    });
    return React.createElement("div", { key: "useOutskirt" }, list);
};
var mapDispatch = function (dispatch) {
    return bindActionCreators({
        onClickShowMe: actionShowMeQuestTaskUseOutskirt,
        onTrySkip: actionBeginBuyWithGoldProcess,
    }, dispatch);
};
export var QuestTaskUseOutskirt = connect(undefined, mapDispatch)(_QuestTaskUseOutskirt);



//////////////////
// WEBPACK FOOTER
// ./src/features/info/quest/list/tasks/questTaskUseOutskirt/QuestTaskUseOutskirt.tsx
// module id = 2681
// module chunks = 3